import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconMergeSvg } from './IconMergeSvg';

export type IconMergeProps = UseIconProps;

export function IconMerge(props: IconMergeProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconMergeSvg} {...iconProps} />;
}
